// Module
var code = `<div class="alert alert--danger">
  Loan moratorium is irreversible
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Loan moratorium start date:</td>
      <td>
        <date
          required
          init-with-null="true"
          ng-model="\$ctrl.parameters.loanMoratoriumStartDate">
        </date>
      </td>
    </tr>
    <tr>
      <td>Should amortizations be moved:</td>
      <td>
        <select
          ng-model="\$ctrl.parameters.moveAmortizations"
          boolean-options
          required>
        </select>
      </td>
    </tr>
    <tr>
      <td>Move by:</td>
      <td>
        <select
          ng-model="\$ctrl.parameters.paymentIntervalDefinitionId"
          ng-options="o.id as o.name for o in \$ctrl.paymentIntervals"
          required>
        </select>
      </td>
    </tr>
    <tr>
      <td>Nr of intervals:</td>
      <td>
        <input
          type="number"
          required
          ng-min="1"
          ng-model="\$ctrl.parameters.intervalCount"
        />
      </td>
    </tr>
    <tr>
      <td>Interest change:</td>
      <td>
        <select
          ng-model="\$ctrl.parameters.interestAdjustmentType"
          ng-options="option.value as option.label for option in \$ctrl.interestChangeOptions"
          required>
        </select>
        <help title="Defines how the interest will change for amortizations that fall in the loan moratorium period"></help>
      </td>
    </tr>
    <tr ng-if="\$ctrl.parameters.interestAdjustmentType === 'STAGGER'">
      <td>Interest stagger end date:</td>
      <td>
        <date
          required
          init-with-null="true"
          ng-model="\$ctrl.parameters.interestStaggerEndDate">
        </date>
      </td>
    </tr>
    <tr>
      <td>Principal change:</td>
      <td>
        <select
          ng-model="\$ctrl.parameters.principalAdjustmentType"
          ng-options="option.value as option.label for option in \$ctrl.principalChangeOptions"
          required>
        </select>
        <help title="Defines how the principal will change for amortizations that fall in the loan moratorium period" ></help>
      </td>
    </tr>
    <tr ng-if="\$ctrl.parameters.principalAdjustmentType === 'STAGGER'">
      <td>Principal stagger end date:</td>
      <td>
        <date
          required
          init-with-null="true"
          ng-model="\$ctrl.parameters.principalStaggerEndDate">
        </date>
      </td>
    </tr>
    <tr>
      <td>Custom fee change:</td>
      <td>
        <select
          ng-model="\$ctrl.parameters.customFeeAdjustmentType"
          ng-options="option.value as option.label for option in \$ctrl.customFeeChangeOptions"
          required>
        </select>
        <help title="Defines how custom fees will change for amortizations that fall in the loan moratorium period" ></help>
      </td>
    </tr>
    <tr>
      <td>Product numbers</td>
      <td>
        <file-id-upload
          single-file="true"
          ng-model="\$ctrl.parameters.fileId"
          validate-uploaded
          required
          show-remarks="false"
          enable-webcam="false"
          max-files="1"
        ></file-id-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download example
    </button>

    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>

<div class="payment-result" ng-if="\$ctrl.processingResults && \$ctrl.processingResults.length > 0">
  <h2 class="section-header">Results</h2>
    <dynamic-list
      columns="\$ctrl.ProcessingResultColumns"
      data="\$ctrl.processingResults">
    </dynamic-list>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/perform-loan-moratorium/perform-loan-moratorium.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;